/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Detail_Renew_Policy_TitleInputs */

const en_subscription_detail_renew_policy_title = /** @type {(inputs: Subscription_Detail_Renew_Policy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renewal Payment Note`)
};

const ar_subscription_detail_renew_policy_title = /** @type {(inputs: Subscription_Detail_Renew_Policy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملاحظة دفع التجديد`)
};

const de_subscription_detail_renew_policy_title = /** @type {(inputs: Subscription_Detail_Renew_Policy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erneuerung Zahlschein`)
};

const es_subscription_detail_renew_policy_title = /** @type {(inputs: Subscription_Detail_Renew_Policy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota de pago de la renovación`)
};

const fr_subscription_detail_renew_policy_title = /** @type {(inputs: Subscription_Detail_Renew_Policy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note sur le renouvellement de l'abonnement`)
};

const it_subscription_detail_renew_policy_title = /** @type {(inputs: Subscription_Detail_Renew_Policy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nota di pagamento per il rinnovo`)
};

const ja_subscription_detail_renew_policy_title = /** @type {(inputs: Subscription_Detail_Renew_Policy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お支払いの更新に関する注意事項`)
};

const ko_subscription_detail_renew_policy_title = /** @type {(inputs: Subscription_Detail_Renew_Policy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`갱신 결제 참고 사항`)
};

const pt_br_subscription_detail_renew_policy_title = /** @type {(inputs: Subscription_Detail_Renew_Policy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Observação sobre a renovação de pagamento`)
};

const ru_subscription_detail_renew_policy_title = /** @type {(inputs: Subscription_Detail_Renew_Policy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Примечание об оплате за продление`)
};

const th_subscription_detail_renew_policy_title = /** @type {(inputs: Subscription_Detail_Renew_Policy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หมายเหตุการต่ออายุการชำระเงิน`)
};

const tr_subscription_detail_renew_policy_title = /** @type {(inputs: Subscription_Detail_Renew_Policy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yenileme Ödeme Notu`)
};

const zh_cn_subscription_detail_renew_policy_title = /** @type {(inputs: Subscription_Detail_Renew_Policy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`续订扣款说明`)
};

const zh_tw_subscription_detail_renew_policy_title = /** @type {(inputs: Subscription_Detail_Renew_Policy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`續訂扣款說明`)
};

/**
* | output |
* | --- |
* | "Renewal Payment Note" |
*
* @param {Subscription_Detail_Renew_Policy_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_detail_renew_policy_title = /** @type {((inputs?: Subscription_Detail_Renew_Policy_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Detail_Renew_Policy_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_detail_renew_policy_title(inputs)
	if (locale === "ar") return ar_subscription_detail_renew_policy_title(inputs)
	if (locale === "de") return de_subscription_detail_renew_policy_title(inputs)
	if (locale === "es") return es_subscription_detail_renew_policy_title(inputs)
	if (locale === "fr") return fr_subscription_detail_renew_policy_title(inputs)
	if (locale === "it") return it_subscription_detail_renew_policy_title(inputs)
	if (locale === "ja") return ja_subscription_detail_renew_policy_title(inputs)
	if (locale === "ko") return ko_subscription_detail_renew_policy_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_detail_renew_policy_title(inputs)
	if (locale === "ru") return ru_subscription_detail_renew_policy_title(inputs)
	if (locale === "th") return th_subscription_detail_renew_policy_title(inputs)
	if (locale === "tr") return tr_subscription_detail_renew_policy_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_detail_renew_policy_title(inputs)
	return zh_tw_subscription_detail_renew_policy_title(inputs)
});